import { render, staticRenderFns } from "./OpenLink.vue?vue&type=template&id=581172a0&scoped=true&"
import script from "./OpenLink.vue?vue&type=script&lang=js&"
export * from "./OpenLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581172a0",
  null
  
)

export default component.exports